<template>
    <router-view v-if="auth.isLoaded" />
    <section
        v-else
        v-loading="!auth.isLoaded"
        class="app-content-spinner"
    />
</template>

<script>
import { mapState } from 'vuex';
import { clearStorageIfHashChanged, saveWebpackHash } from 'shared-lib/helpers/local-storage';
import EventBus from 'shared-lib/helpers/eventBus';

export default {
    name: 'App',

    computed: mapState(['auth']),

    created () {
        if (typeof __webpack_hash__ !== 'undefined') {
            clearStorageIfHashChanged();
            saveWebpackHash();
        }

        EventBus.$on('logout', () => {
            this.$store.state.auth.isLogged && this.$store.dispatch('logout')
                .then(() => this.$message.warning({ message: this.$t('loggedOut') }))
                .then(() => this.$router.push('/login'));
        });

        // init authorization
        this.$store.dispatch('initAuth');
    },
};
</script>


<style lang="scss">
    .app-content-spinner {
        min-width: 100%;
        min-height: 100%;
        margin: 0;
        padding: 0;
    }
</style>
